import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const argoCdTranslationRef = createTranslationRef({
  id: 'plugin-argo-cd',
  messages: {
    details: {
      defaultTitle: 'ArgoCD overview',
      columnName: 'Name',
      columnSyncStatus: 'Sync Status',
      columnHealthStatus: 'Health Status',
      columnLastSynced: 'Last Synced',
      columnInstance: 'Instance',
      columnActions: 'Actions',
      refresh: 'Refresh',
      fetchError: 'Error occurred while fetching data. {{name}}: {{message}}',
    },
    history: {
      title: 'ArgoCD history',
      fetchError: 'Error occurred while fetching data. {{message}}',
    },
    historyTable: {
      title: 'ArgoCD history',
      columnName: 'Name',
      columnDeployDetails: 'Deploy Details',
      columnAuthor: 'Author',
      columnMessage: 'Message',
      columnRevision: 'Revision',
      columnInstance: 'Instance',
      deployedAt: 'Deployed at {{date}}',
      run: 'Run {{value}}',
      took: 'Took {{value}}',
      loading: 'Loading...',
      refresh: 'Refresh',
    },
    drawer: {
      argoInstance: 'Argo CD Instance',
      repoUrl: 'Repository URL',
      repoPath: 'Repository path',
      destinationServer: 'Destination server',
      destinationNamespace: 'Destination namespace',
      syncStatus: 'Sync status',
      images: 'Images',
      link: 'Link',
      openDashboard: 'Open Argo CD Dashboard',
      argoName: 'Argo Name: {{name}}',
      closeDrawer: 'Close the drawer',
    },
    historyRollback: {
      openDrawer: 'History & Rollback',
      drawerTitle: 'History & Rollback',
      closeDrawer: 'Close the drawer',
      empty: 'No revisions found',
      revisionLabel: 'Revision:',
      currentRevision: 'Current',
      deployedAt: 'Deployed {{date}}',
      revisionsCount: 'Revisions:',
      autoSyncEnabled: 'Auto-sync enabled',
      autoSyncDisabled: 'Auto-sync disabled',
      authoredBy: 'Authored by',
      enableAutoSync: 'Enable auto-sync',
      disableAutoSync: 'Disable auto-sync',
      rollback: 'Rollback',
      redeploy: 'Redeploy',
      confirmTitle: '{{action}} application',
      confirmMessage:
        'Are you sure you want to {{action}} application "{{appName}}"?',
      confirmMessageDisableAutoSync:
        'Auto-Sync needs to be disabled in order for {{action}} to occur. Are you sure you want to disable auto-sync and {{action}} application "{{appName}}"?',
      historyEntryMissingWarning:
        'Application history has changed. Refresh the list of revisions and try again.',
      ok: 'OK',
      cancel: 'Cancel',
      notAvailable: 'n/a',
    },
    appData: {
      missingAnnotation: "'argocd' annotation is missing",
      conflictingAnnotations:
        "Cannot provide both 'argocd/app-name' and 'argocd-app' annotations",
    },
    appDetails: {
      neitherAppNameNorSelectorProvided:
        'Neither appName nor appSelector provided',
      somethingWentWrong: 'Something went wrong',
      missingStatus: 'Missing',
    },
  },
  translations: {},
});
